import { createFileRoute } from '@tanstack/react-router';
import { ProcessesListPage } from '@/pages/processes/all-processes/ProcessesListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/processes/all-processes/')({
  component: ProcessesListPage,
  validateSearch: dataTableSearchSchema({})
});
